import { render, staticRenderFns } from "./MultipleSelectCustom.vue?vue&type=template&id=9c20c0ca"
import script from "./MultipleSelectCustom.vue?vue&type=script&lang=js"
export * from "./MultipleSelectCustom.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectCustom.vue?vue&type=style&index=0&id=9c20c0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports